/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN, API_KOTLIN_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import { GETCLUBLEVELLIST } from './constants'
import headers from '../../api/employeeSystemHeader'
export const getClubLevelList = (payload) => {
  return {
    type: GETCLUBLEVELLIST,
    payload,
  }
}

//等级列表
export function fetchLevelList() {
  return (dispatch, getState) => {
    const club = sessionStorage.getItem('club_id')
    const endpoint = `${API_KOTLIN_DOMAIN}/discount`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubLevelList(data.list))
      return data
    })
  }
}

//删除
export function fetchDelLevel(id) {
  return (dispatch, getState) => {
    const endpoint = `${API_KOTLIN_DOMAIN}/Manage/MemberApi/DelDiscount/id/${id}`
    return fetchData(endpoint).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        dispatch(fetchLevelList())
      } else {
        message.error(data.detail)
      }
    })
  }
}

//修改
export function fetchEditLevel(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_KOTLIN_DOMAIN}/discount/editLevel`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        dispatch(fetchLevelList())
      } else {
        message.error(data.detail)
      }
    })
  }
}
// export function fetchEditLevel(body) {
//   return (dispatch, getState) => {
//     const endpoint = `${API_DOMAIN}/Manage/MemberApi/UpdateDiscount`
//     return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
//       if (data.status === true) {
//         message.success(data.detail)
//         dispatch(fetchLevelList())
//       } else {
//         message.error(data.detail)
//       }
//     })
//   }
// }

//增加
export function fetchAddLevel(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_KOTLIN_DOMAIN}/discount/addLevel`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchLevelList())
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}
// export function fetchAddLevel(body) {
//   return (dispatch, getState) => {
//     const endpoint = `${API_DOMAIN}/Manage/MemberApi/AddDiscount`
//     return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
//       if (data.status === true) {
//         dispatch(fetchLevelList())
//         message.success(data.detail)
//       } else {
//         message.error(data.detail)
//       }
//     })
//   }
// }



// WEBPACK FOOTER //
// ./src/containers/ClubLevel/action.js